import { render } from "./CopyToClipboardText.vue?vue&type=template&id=1cf77520&scoped=true"
import script from "./CopyToClipboardText.vue?vue&type=script&lang=js"
export * from "./CopyToClipboardText.vue?vue&type=script&lang=js"

import "./CopyToClipboardText.vue?vue&type=style&index=0&id=1cf77520&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cf77520"]])

export default __exports__